import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import DashboardDevices from './dashboard-devices'
import { UserPermissions } from '../../services/permissions'
import DashboardReports from './dashboard-reports'
import { MapView } from './map-view/map-view'
import { useSelector } from 'react-redux'
import { DASHBOARD_MAP_SWITCHER_OPTIONS } from '../root/constants'

const useStyles = makeStyles(() => ({
    wrapper: {
        margin: '-25px -50px -25px -50px',
        height: 'calc(100% + 50px)'
    },
    dashboardWrapper: {
        padding: '25px 50px 25px 50px',
        width: '100%',
        height: '100%'
    }
}))

export default function Dashboard() {
    const classes = useStyles()
    const { dashboardType } = useSelector(state => state.main)

    const permissions = {
        readDevices: UserPermissions.device().read,
        readReports: UserPermissions.report().read,
        readLocations: UserPermissions.location().read
    }

    return (
        <div className={classes.wrapper}>
            {dashboardType ===
            DASHBOARD_MAP_SWITCHER_OPTIONS.dashboard.value ? (
                <div className={classes.dashboardWrapper}>
                    {permissions.readDevices && <DashboardDevices />}
                    {permissions.readReports && <DashboardReports />}
                </div>
            ) : (
                permissions.readLocations && <MapView />
            )}
        </div>
    )
}
